// extracted by mini-css-extract-plugin
export default {"container":"MY-z","list":"NY-z"};